import React from 'react';
import { motion } from 'framer-motion';
import { XIcon, CheckIcon, FrownIcon, SmileIcon } from 'lucide-react';
const beforeItems = ['Abrís la heladera y te quedás paralizada', 'Pedís delivery por desesperación', 'Cocinás siempre lo mismo', 'La hora de la cena te genera ansiedad', 'Perdés tiempo pensando qué hacer'];
const afterItems = ['Abrís el PDF y elegís en 30 segundos', 'Tenés 30 recetas listas para resolver', 'Rotás con variedad real toda la semana', 'La cena se resuelve en 15 minutos', 'Usás ese tiempo en lo que importa'];
export function TransformationSection() {
  return <section className="w-full py-10 md:py-12 px-6 bg-cream" data-id="element-111">
      <div className="max-w-4xl mx-auto" data-id="element-112">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.5
      }} className="text-center mb-8" data-id="element-113">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-brown-dark mb-3" data-id="element-114">
            ✨ Lo que realmente te llevás
          </h2>
          <p className="font-body text-lg md:text-xl text-brown-light max-w-2xl mx-auto leading-relaxed" data-id="element-115">
            Un sistema completo de recetas diseñado para mamás argentinas
            ocupadas: resolvé la comida familiar en 15 minutos o menos, con
            ingredientes simples que ya tenés en casa. Esto es lo que cambia en
            tu vida:
          </p>
        </motion.div>

        {/* Transformation Image */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.5
      }} className="mb-8 max-w-2xl mx-auto" data-id="element-116">
          <img src="https://cdn.magicpatterns.com/uploads/fHPaEmUkALbzUkxm4wiqq9/mama_expres_foto_4.png" alt="Mamá cocinando con alegría en su cocina, revolviendo una sartén con ingredientes frescos" className="w-full rounded-2xl shadow-warm object-cover aspect-[16/9]" data-id="element-117" />
        </motion.div>

        <div className="grid md:grid-cols-2 gap-4 md:gap-6" data-id="element-118">
          {/* Before Column */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5
        }} className="bg-red-50/50 rounded-2xl p-5 md:p-6 border border-red-200/50" data-id="element-119">
            <div className="flex items-center gap-3 mb-4" data-id="element-120">
              <div className="w-10 h-10 bg-red-100 rounded-full flex items-center justify-center" data-id="element-121">
                <FrownIcon className="w-5 h-5 text-red-500" data-id="element-122" />
              </div>
              <h3 className="font-heading text-xl font-bold text-red-700" data-id="element-123">
                ANTES
              </h3>
            </div>

            <div className="space-y-3" data-id="element-124">
              {beforeItems.map((item, index) => <motion.div key={index} initial={{
              opacity: 0,
              x: -10
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.3,
              delay: index * 0.1
            }} className="flex items-start gap-3" data-id="element-125">
                  <div className="flex-shrink-0 w-6 h-6 bg-red-200/50 rounded-full flex items-center justify-center mt-0.5" data-id="element-126">
                    <XIcon className="w-4 h-4 text-red-500" data-id="element-127" />
                  </div>
                  <p className="font-body text-brown-dark" data-id="element-128">{item}</p>
                </motion.div>)}
            </div>
          </motion.div>

          {/* After Column */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="bg-green-50 rounded-2xl p-5 md:p-6 border border-green-200/50" data-id="element-129">
            <div className="flex items-center gap-3 mb-4" data-id="element-130">
              <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center" data-id="element-131">
                <SmileIcon className="w-5 h-5 text-green" data-id="element-132" />
              </div>
              <h3 className="font-heading text-xl font-bold text-green" data-id="element-133">
                DESPUÉS
              </h3>
            </div>

            <div className="space-y-3" data-id="element-134">
              {afterItems.map((item, index) => <motion.div key={index} initial={{
              opacity: 0,
              x: 10
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.3,
              delay: index * 0.1
            }} className="flex items-start gap-3" data-id="element-135">
                  <div className="flex-shrink-0 w-6 h-6 bg-green/20 rounded-full flex items-center justify-center mt-0.5" data-id="element-136">
                    <CheckIcon className="w-4 h-4 text-green" data-id="element-137" />
                  </div>
                  <p className="font-body text-brown-dark" data-id="element-138">{item}</p>
                </motion.div>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}